/*
 *   File :  email-preview.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Message content
 *   Integrations :
 *   Version : v1.0
 */

/*import packages*/
import React from 'react';

import styles from '../../styles/components/emailPreview.module.scss';

export default function EmailPreview(props) {

    return (
        <div className={`${styles.e_view_content} modal fade`}
            id={"view-email"}
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="view-email"
            aria-hidden="true">
            <div className={`${styles.e_modal_dialog} modal-dialog modal-dialog-centered`}>
                <div className={`${styles.e_content} modal-content p-4`}>
                    <div className='d-flex justify-content-between mt-2'>
                        <h5 className=''>{props.title}</h5>
                        <button type="button" id="close-mr" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            style={{ width: "8px", height: "8px" }}></button>
                    </div>
                    
                    <div className={`${styles.e_preview_scroll} e-html-wrapper`}>
                        <div
                            className={`${styles.e_preview} mira-html-content`}
                            dangerouslySetInnerHTML={{ __html: props.html }}
                        />
                    </div>

                </div>

            </div>
        </div>
    )
}